import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { withAccount } from '../../../components/AccountContext';
import SurveyRespondentCard from './SurveyRespondentCard';
import ArrayUtil from '../../../utils/ArrayUtil';
import { AsyncSelector } from '../../../components/selector/AsyncSelector';
import { intlShape } from '../../../components/prop-types';
import AddRespondentForm from '../new/components/AddRespondentFormContainer';

const surveyGroupTypeMessages = defineMessages({
  managers: { id: '360.managers', defaultMessage: 'Bosses' },
  peers: { id: '360.peers', defaultMessage: 'Peers' },
  directReports: { id: '360.directReports', defaultMessage: 'Direct Reports' },
  others: { id: '360.others', defaultMessage: 'Others' },
});

const messages = defineMessages({
  addRespondent: {
    id: 'candidate.add',
    defaultMessage: 'Add Respondent',
  },
});

class SurveySubRespondents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: [0],
      isAddingFormShown: false,
    };
    this.tabChange = this.tabChange.bind(this);
    this.showAddingForm = this.showAddingForm.bind(this);
  }

  tabChange(event) {
    const { index } = event;
    this.setState({ activeIndex: index });
  }

  showAddingForm(isAddingFormShown) {
    this.setState({
      isAddingFormShown,
    });
  }

  render() {
    const {
      type,
      isEdit,
      respondentsSearch,
      respondentList,
      processing,
      selectedRespondents,
      subRespondents,
      intl: { formatMessage },
      onChangeCheckedRespondent,
      onChangeRespondentCategory,
      reportObservers,
    } = this.props;
    const {
      onRemove, onAdd,
    } = this.props;
    const sortedSubRespondents = ArrayUtil.sortSurveyRespondentAlphabet(subRespondents);
    const groupName = formatMessage(surveyGroupTypeMessages[type]);
    const { activeIndex, isAddingFormShown } = this.state;
    const addRespondentLabel = formatMessage(messages.addRespondent);
    return (
      <div className="accordion-legacy-container">
        <Accordion
          multiple
          activeIndex={activeIndex}
          onTabChange={this.tabChange}
        >
          <AccordionTab header={groupName}>
            {ArrayUtil.isEmpty(sortedSubRespondents) && (
              <FormattedMessage id="candidate.empty" defaultMessage="Empty" />
            )}

            {sortedSubRespondents.map(r => (
              <SurveyRespondentCard
                key={r.respondent.id}
                isEdit={isEdit}
                type={type}
                assessment={r}
                onRemove={id => onRemove(id, type)}
                onChangeRespondentCategory={onChangeRespondentCategory}
                onChangeCheckedRespondent={onChangeCheckedRespondent}
                reportObservers={reportObservers}
              />
            ))}
            {isEdit && (
              <div className="field">
                <div className="field-label field-label--small t-small">
                  <p>
                    <FormattedMessage id="actions.assign" defaultMessage="Assign" />
                    {` ${groupName}`}
                  </p>
                </div>

                <div className="field-controls">
                  <FormattedMessage id="placeholder.autocomplete.name" defaultMessage="Start typing a name">
                    {text => (
                      <AsyncSelector
                        placeholder={text}
                        filter="contains"
                        value={null}
                        dataSearch={respondentsSearch}
                        onChange={value => onAdd(value, type)}
                        data={respondentList}
                        processing={processing}
                        selectedList={selectedRespondents}
                        valueField="id"
                        textField={item => (item ? `${item.firstName} ${item.lastName}` : '')}
                      />
                    )}
                  </FormattedMessage>
                </div>

                <div>
                  {
                isAddingFormShown
                  ? (
                    <AddRespondentForm
                      type={type}
                      onAdd={onAdd}
                      toggleEdit={this.showAddingForm}
                    />
                  )
                  : (
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label={addRespondentLabel}
                      onClick={() => {
                        this.showAddingForm(true);
                      }}
                    />
                  )
              }
                </div>
              </div>
            )}
          </AccordionTab>
        </Accordion>
      </div>
    );
  }
}

SurveySubRespondents.propTypes = {
  type: PropTypes.string.isRequired,
  isEdit: PropTypes.bool.isRequired,
  respondentsSearch: PropTypes.func.isRequired,
  respondentList: PropTypes.arrayOf(PropTypes.any).isRequired,
  processing: PropTypes.bool.isRequired,
  selectedRespondents: PropTypes.arrayOf(PropTypes.any).isRequired,
  subRespondents: PropTypes.arrayOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  onChangeCheckedRespondent: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onChangeRespondentCategory: PropTypes.func.isRequired,
  reportObservers: PropTypes.arrayOf(PropTypes.string).isRequired,
};


export default withAccount(injectIntl(SurveySubRespondents));
